import { Route, Routes } from '@angular/router';

import { NewsMediaContentComponent } from './news-media-content/news-media-content.component';
import { NewsMediaComponent } from './news-media.component';

export const NEWS_MEDIA_CHILD_ROUTES: Routes = [
  { path: '', redirectTo: 'in-the-news', pathMatch: 'full' },
  {
    path: 'in-the-news',
    component: NewsMediaContentComponent,
    data: { canonicalPath: 'news-media/in-the-news' },
  },
  {
    path: 'reports',
    component: NewsMediaContentComponent,
    data: { canonicalPath: 'news-media/reports' },
  },
  {
    path: 'press-releases',
    component: NewsMediaContentComponent,
    data: { canonicalPath: 'news-media/press-releases' },
  },
];

export const NEWS_MEDIA_ROUTE: Route = {
  path: 'news-media',
  component: NewsMediaComponent,
  data: { pageHeadingKey: 'NEWS-MEDIA' },
  children: NEWS_MEDIA_CHILD_ROUTES,
};
